<div class="view-container">
@if (medicine) {
  <mat-card class="medicine-view-card">
    <mat-card-content class="medicine-view-card__content">
      <div class="medicine-view-card__header">
        <div class="medicine-view-card__title-row">
          <div class="medicine-view-card__icon">
            <mat-icon>medication</mat-icon>
          </div>
          <div>
            <h1 class="medicine-view-card__title">{{ medicine.name }}</h1>
          </div>
        </div>

        <div class="medicine-view-card__header-actions">
          <button
            *authGroup="['SuperAdmin']"
            type="button"
            mat-stroked-button
            color="warn"
            class="medicine-view-card__delete-btn"
            (click)="delete()"
          >
            Delete
          </button>
          @if (perm.canEditMedicineCatalogue()) {
            <button
              type="button"
              color="primary"
              mat-flat-button
              class="medicine-view-card__edit-btn"
              (click)="editMode = !editMode"
            >
              {{ editMode ? 'Details' : 'Edit' }}
            </button>
          }
        </div>
      </div>

      <div class="medicine-view-card__actions">
        <button type="button" mat-stroked-button class="medicine-view-card__action-btn" (click)="backToList()">
          <mat-icon>arrow_back</mat-icon>
          Back to list
        </button>
      </div>

      @if (editMode) {
        <form class="medicine-view-card__form mt-3" [formGroup]="medicineForm">
          <div class="row">
            <div class="col-md-6">
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Name</mat-label>
                  <input formControlName="name" type="text" matInput>
                  @if (medicineForm.get('name')?.invalid) {
                    <mat-error>Name is invalid</mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Barcode prefix</mat-label>
                  <input formControlName="barcodePrefix" type="text" matInput>
                  @if (medicineForm.get('barcodePrefix')?.invalid) {
                    <mat-error>Barcode prefix is invalid</mat-error>
                  }
                </mat-form-field>
              </p>
            </div>
            <div class="col-md-6">
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Active ingredient</mat-label>
                  <input formControlName="activeIngredient" type="text" matInput>
                  @if (medicineForm.get('activeIngredient')?.invalid) {
                    <mat-error>Active ingredient is invalid</mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Active ingredient nappy code</mat-label>
                  <input formControlName="activeIngredientNappyCode" type="text" matInput>
                  @if (medicineForm.get('activeIngredientNappyCode')?.invalid) {
                    <mat-error>Active ingredient nappy code is invalid</mat-error>
                  }
                </mat-form-field>
              </p>
            </div>
          </div>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Schedule status</mat-label>
              <mat-select formControlName="scheduleStatus">
                @for (status of scheduleStatuses; track status) {
                  <mat-option [value]="status">{{ status }}</mat-option>
                }
              </mat-select>
              @if (medicineForm.get('scheduleStatus')?.invalid) {
                <mat-error>Schedule status is invalid</mat-error>
              }
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Description</mat-label>
              <textarea formControlName="description" matInput></textarea>
              @if (medicineForm.get('description')?.invalid) {
                <mat-error>Description is invalid</mat-error>
              }
            </mat-form-field>
          </p>
        </form>
        <div class="medicine-view-card__footer">
          <button type="button" (click)="save()" mat-flat-button color="primary" class="medicine-view-card__btn--primary">
            <mat-icon>save</mat-icon> Save
          </button>
        </div>
      }

      @if (!editMode) {
        <div class="details">
          <table>
            <tr>
              <th>Name</th>
              <td>{{ medicine.name ? medicine.name : '-' }}</td>
            </tr>
            <tr>
              <th>Description</th>
              <td>{{ medicine.description ? medicine.description : '-' }}</td>
            </tr>
            <tr>
              <th>Barcode prefix</th>
              <td>{{ medicine.barcode_prefix ? medicine.barcode_prefix : '-' }}</td>
            </tr>
            <tr>
              <th>Active ingredient</th>
              <td>{{ medicine.active_ingredient ? medicine.active_ingredient : '-' }}</td>
            </tr>
            <tr>
              <th>Active ingredient nappy code</th>
              <td>{{ medicine.active_ingredient_nappy_code ? medicine.active_ingredient_nappy_code : '-' }}</td>
            </tr>
            <tr>
              <th>Schedule status</th>
              <td>{{ medicine.schedule_status }}</td>
            </tr>
            <tr>
              <th>Created</th>
              <td>{{ formatTime(medicine.created_at) }}</td>
            </tr>
            <tr>
              <th>Updated</th>
              <td>{{ formatTime(medicine.updated_at) }}</td>
            </tr>
          </table>
        </div>
      }

      <div class="medicine-view-card__dosage-section">
        <div class="medicine-view-card__dosage-header">
          <h2 class="medicine-view-card__section-title">Dosage and package types</h2>
          <div class="medicine-view-card__dosage-actions">
            <button *authGroup="['SuperAdmin']" type="button" mat-stroked-button class="medicine-view-card__action-btn" (click)="createMedicineDosageType()">
              <mat-icon>add</mat-icon> Create new
            </button>
            <button type="button" mat-stroked-button class="medicine-view-card__action-btn" (click)="refreshMedicineDosageTypes(true)">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
        <core-medicine-dosage-types-list
          [medicineId]="medicine.id"
          (onMedicineDosageTypeUpdated)="refreshMedicineDosageTypes($event)"
          [medicineDosageTypes]="medicineDosageTypes"
          [dosageTypes]="dosageTypes"
          [packageTypes]="packageTypes"
          [dosageUnits]="dosageUnits"
        ></core-medicine-dosage-types-list>
      </div>
    </mat-card-content>
  </mat-card>
}
</div>
